import React from 'react';

const PromotionBox = ({ description }) => {
  return (
    <div className="delivery-box">
      <div className="icon">
        <i className="fal fa-badge-percent" />
      </div>
      <div className="details">
        <h6>
          {I18n.t("pages.venues.show.venue_details.promotion")}
        </h6>
        <p>
          {description}
        </p>
      </div>
    </div>
  )
}

export default PromotionBox;
